export enum BranchType {
	DEV = 'Dev',
	TEST = 'Test',
	PROD = 'Prod',
}
